import React from 'react';
import PropTypes from 'prop-types';
import { LinkElement } from '@els/els-react--link-element';

function ExampleQuery({ dataE2e, onExampleClick = () => {}, value, withExamplesLinks = true, withQuotes = true }) {
  if (!withExamplesLinks) {
    return withQuotes ? `"${value}"` : value;
  }

  return (
    <LinkElement
      href="#"
      inline
      data-e2e={dataE2e}
      onClick={(event) => {
        event.preventDefault();
        onExampleClick(value);
      }}>
      {value}
    </LinkElement>
  );
}

ExampleQuery.propTypes = {
  dataE2e: PropTypes.string.isRequired,
  onExampleClick: PropTypes.func,
  value: PropTypes.string.isRequired,
  withExamplesLinks: PropTypes.bool,
  withQuotes: PropTypes.bool,
};

export default ExampleQuery;
